import { default as List } from './RepList';
import { default as View } from './RepView';
export default {
	List,
	View
};
